import React, { type SVGProps } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { CustomIconProps } from '@/shared/ui/icon-template'

import cl from './StepList.module.scss'

export interface propsType {
	icon: React.FC<CustomIconProps | SVGProps<SVGSVGElement>>
	title: string
	subtitle: string
}

const StepList: React.FC<{ itemList: propsType[] }> = ({ itemList }) => {
	return (
		<ul className={cl.list}>
			{itemList.map((item, index) => (
				<li key={index} className={cl.list__item}>
					<div className={cl.list__iconContainer}>{<item.icon width={40} height={40} />}</div>
					<div className={cl.list__textWrapper}>
						<h4 className={cl.list__itemTitle} dangerouslySetInnerHTML={createMarkup(item.title)} />
						<p className={cl.list__itemSubtitle} dangerouslySetInnerHTML={createMarkup(item.subtitle)} />
					</div>
				</li>
			))}
		</ul>
	)
}

export default StepList
